import constants, {
  LOGIN_METHOD_EMAIL_OTP,
  LOGIN_METHOD_EMAIL_PHONE_OTP
} from '../constants';

const getBackend = ({ loginType, loginMethod, otpOrEmailResponse }) => {
  let backend = 'phone';
  if (loginType === constants.LOGIN_TYPE_EMAIL && otpOrEmailResponse) {
    backend = 'email';
    if (loginMethod === LOGIN_METHOD_EMAIL_PHONE_OTP) backend = 'email_phone';
    if (loginMethod === LOGIN_METHOD_EMAIL_OTP) backend = 'email_otp';
  }

  return backend;
};

export default getBackend;
